import styled from 'styled-components';

export const getTileGradient = (color) => {

    let newColor = color + "00"

    return (
        `linear-gradient(180deg, ${newColor} 0%, ${color} 100%)`
    )
}

export const StyledTilesPageContainer = styled.div`
    overflow: hidden;
`;

export const TilesPageBackground = styled.div`
    width: 100vw;
    height: 100vh;
    position: relative;
    background: ${({ theme }) => theme?.themeC4};
    video {
        object-fit: cover;
    }
`
export const BackgroundTransition = styled.div`
    position: relative;
    margin-top: -20vh;
    height: 20vh;
    width: 100%;
    background: linear-gradient(to bottom, rgba(30,31,35,0), rgba(30,31,35,1));
    // background: ${({ theme }) => getTileGradient(theme?.themeC4)};
    background-size: 100%;
    background-repeat: no-repeat;
`;

export const TileContainer = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
`


export const TilesPageImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`

export const MuteUnmuteIcon = styled.img`
    width: 25px;
    height: 25px;
    position: absolute;
    top: 100px;
    right: 1.5vw;
    z-index: 99;
    &:hover {
        cursor: pointer;
    }
`

export const StyledTilesList = styled.div`
    // background: linear-gradient(to bottom, #1e1f2300, #1e1f23ff);
    background: ${({ theme }) => theme?.themeC4};
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
`;


